import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UmbracoImage } from 'src/core-lib/umbraco/umbraco-image.model';
import { BoxSettings, ColorSettings, SettingsSetterDirective } from '../../models/general-element-settings';

interface Article {
    Url?: string;
    media?: UmbracoImage;
    text: string;
    title?: string;
    pageTitle?: string;
}
type BoxNColors = Partial<BoxSettings> & Partial<ColorSettings>;

export interface BlockSliderSettings extends BoxNColors {
    gap: string;
    arrows: boolean;
    scrollbar: boolean;
    scrollHint: boolean;
    scrollStart: number;
    showSize: number;
    oneAtATime: boolean;
    minWidth: string;
}
@Component({
    selector: 'app-articles',
    templateUrl: './articles.component.html',
    styleUrls: ['./articles.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ArticlesComponent extends SettingsSetterDirective {
    articles: Article[];
    declare settings: BlockSliderSettings;

    imgSize: string;
    ngOnInit(): void {
        super.ngOnInit()
        let _elm = this.elm.nativeElement;
        if(this.settings?.showSize == 1)
            this.imgSize = 'content-full';
        else if(this.settings?.showSize == 2)
            this.imgSize = 'content-half';
        else if(this.settings?.showSize == 3)
            this.imgSize = 'content-third';
        else
            this.imgSize = 'content-quart';
    }

}
